<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2 mt-3">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Afficher</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entrées</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filterInput"
                  type="search"
                  placeholder="Saisissez votre recherche"
                  @keyup="applyFilter"
                />
                <b-input-group-append>
                  <b-button
                    @click="applyFilterEnter"
                  >
                    Rechercher
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="6"
          />
          <!-- Filter On -->
          <b-col
            cols="12"
            md="6"
          >
          </b-col>
        </b-row>

        <!-- Tableau -->
        <b-row>
          <b-col cols="12">
            <b-table
              id="datatables"
              class="mt-4 mb-4"
              :items="documents"
              :fields="fields"
              stacked="md"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              striped
              small
              @filtered="onFiltered"
              @row-clicked="selectedCol"
            >
              <!-- IMAGES -->
              <template #cell(image)="data">
                <img :src=data.value height="40" width="auto"/>
              </template>

              <!-- PRIX -->
              <template #cell(prix)="data">
                <span>{{ parseFloat(data.value).toFixed(2) }} {{ setting.devise }} HT </span><br />
                <span style="font-size: 0.8em;">{{ parseFloat( data.value +  (data.value * (data.item.tva /100))).toFixed(2) }} {{ setting.devise }} TTC</span>
              </template>

              <!-- FAMILLES -->
              <template #cell(categoriesarticles)="data">
                <span v-for="(famille, familleindex) in data.item.categoriesarticles"
                  :key="familleindex">
                  <span v-if="familleindex != data.item.categoriesarticles.length - 1">,</span>
                </span>  
              </template>

              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  :to="{name: 'viewarticle', params: { id: data.item.key }}"
                  variant="flat-success"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon icon="EyeIcon" />
                </b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          />
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BTable,
  BLink,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
  BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'
import moment from 'moment'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BTable,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    BImg,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      documents: [],
      isLoading: true,
      drawer: true,
      perPage: 50,
      currentPage: 1,
      totalRows: 1,
      currentPage: 1,
      filterInput: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      outlined: true,
      filterOn: [],
      sortBy: 'nom',
      sortDirection: 'asc',
      sortDesc: false,
      localDB: new PouchDB(localStorage.getItem('database')),
      remoteDB: new PouchDB(localStorage.getItem('url')+'/'+localStorage.getItem('database')),
      setting: JSON.parse(localStorage.setting),
      commercial: JSON.parse(localStorage.commercial),
      fields : [
        { key: 'nom', label: 'Nom', sortable: true },
        { key: 'actions', label: '', thStyle: { width: '10px' } },
      ]
    }
  },
  computed: {
    /**
      * Total no. of records
      */
    rows() {
      return this.items.length
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {},
  created() {
    this.localDB.find({ selector: { type: 'clients' } }, this.setDocuments)
  },
  mounted() {},
  customButtons: {
    default: true,
  },
  methods: {
    setDocuments(err, doc) {
      if (err) {
        console.log('err', err)
      }
      console.log('doc', doc)
      for (let i = 0; i < doc.docs.length; i++) {
        this.documents.push({
          key: doc.docs[i]._id,
          rev: doc.docs[i]._rev,
          nom: doc.docs[i].nom,
        })
      }
      // console.log("product", this.documents)
      this.totalRows = this.documents.length
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    applyFilter() {
      if(this.filterInput.length >= 3) {
          this.filter = this.filterInput
      } else {
          this.filter = ''
      }
    },
    applyFilterEnter() {
      this.filter = this.filterInput
    },
    selectedCol(item) {
      this.$router.push({  name: 'viewarticle', params: { id: item.key }  })
    }
  },
}
</script>

<style>
    .btn-primary {
        margin-right: 12px;
    }
    .per-page-selector {
      width: 90px;
    }
    .btNopadding button {
      padding: 0;
    }
    table tbody tr {
      height: 60px;
    }
    @media (max-width: 767.98px) {
      .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
        text-align: left;
      }
    }
</style>

<style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
</style>
